import React, { useState } from "react";
import Div100vh from "react-div-100vh";
import GoBackButton from "../common/buttons/GoBackButton";
import bgBhai from "@/assets/images/bubbles.jpg";
import BgVideo from "@/assets/videos/conog_bg.mp4";
import { chatHelpMessage } from "@/lib/helper";
// import WhatsappIcon from "@/assets/icons/whatsapp-icon-green.svg";
import WhatsappIcon from "@/assets/icons/whatsapp-icon.svg";
import { Download } from "lucide-react";
import Header from "../common/Header/header";
import Loader from "../common/Loader";
import { motion } from "framer-motion";
import { headingVariants, NCR_REGIONS } from "@/lib/data";
import { userDataAtom } from "@/recoil/atom/userDataAtom";
import { useRecoilValue } from "recoil";

export default function HowItWorks({ setBenefitsDrawer }) {
  const [selectedTab, setSelectedTab] = useState("landlord");
  const [isDownloading, setisDownloading] = useState(false);
  const userData = useRecoilValue(userDataAtom);
  
  const steps = [
    {
      number: 1,
      title: "Finalise your new home & move-in date",
      description: "",
    },
    {
      number: 2,
      title: "We generate a unique club offer for your landlord",
      subPoints: [`${NCR_REGIONS.includes(userData.moveInCity) ? "8" : "10"} Month Advance Rent`, "1 Month Security Deposit"],
      description: "",
    },
    {
      number: 3,
      title: "Our expert connects with you & enables Zero Deposit",
      description: "",
    },
  ];

  return (
    <Div100vh
      className="flex flex-col space-y-subheading-input bg-[#010101] py-4"
      style={{
        backgroundImage: `linear-gradient(to bottom right, rgba(0, 0, 0) 10%, rgba(0, 19, 191) 500%)`,
      }}
    >
      <div className="p-4 px-10 sm:p-10 flex flex-col overflow-scroll">
        {/* <motion.h1
          className="reveal-heading"
          initial="hidden"
          animate="visible"
          variants={headingVariants}
        > */}
        <span className="text-xl font-medium">How It Works ?</span>
        {/* </motion.h1> */}
        {/* <Header heading="How It Works ?" /> */}
        <div className="text-white space-y-8 mt-6 gap-4 flex flex-col">
          {steps.map((step, index) => (
            <div
              key={index}
              className="p-[0.5px] bg-gradient-to-b from-[#bbb] via-[#444] to-[#000]"
            >
              <div className="flex items-center p-3 sm:p-6 bg-gradient-to-b min-h-32 from-[#171717] to-[#000]">
                {/* Step Number */}
                <div className="text-5xl sm:text-5xl font-medium text-[#919191] mr-6">
                  {step.number}
                </div>

                {/* Step Details */}
                <div>
                  <h2 className="text-sm text-white font-medium leading-6 mb-2">
                    {step.title}
                  </h2>
                  {step.subPoints && Array.isArray(step.subPoints) && (
                    <ul className="list-disc pl-4 bg-clip-text text-transparent bg-gradient-to-r from-[#EEEEEE] via-[#1987FB] to-[#EEEEEE] text-xs space-y-1">
                      {step.subPoints.map((point, index) => (
                        <li key={index} className="">
                          {point}
                        </li>
                      ))}
                    </ul>
                  )}
                  <p className="text-gray-400 text-2xs">{step.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
        {/* {isDownloading ? (
          <Loader />
        ) : (
          <a
            onClick={() => {
              // dropWaMessage(
              //   "Share CLUB invite",
              //   "Invite Screen - Tenant flow"
              // )
              setisDownloading(true);
              setTimeout(() => {
                setisDownloading(false);
              }, 1000);
            }}
            href={"download/pdfs/Landlord Brochure_CirclePe.pdf"}
            rel="noopener noreferrer"
            download={"Landlord Brochure_CirclePe.pdf"}
            target="_blank"
            className="w-full p-4 text-[#cccccc] font-semibold my-2 flex gap-2 border justify-between items-center border-[#ccc]"
          >
            <span className="min-w-max">Download Landlord Brochure</span>

            <Download size={18} />
          </a>
        )} */}

        {/* <a
          // onClick={() =>
          //   dropWaMessage(
          //     "Share CLUB invite",
          //     "Invite Screen - Tenant flow"
          //   )
          // }

          className="w-full p-4 text-[#cccccc]/0 font-semibold my-2 flex gap-2 border justify-between items-center border-[#ccc]/0"
        >
          <span className="min-w-max">Download Landlord Brochure</span>

          <Download size={18} />
        </a> */}
      </div>
    </Div100vh>
  );
}
